import * as React from "react";
import {ChangeEvent} from "react";
import {IOption} from "../../types";

// tslint:disable-next-line:interface-name
interface FilterOptionProps {
    id: string,
    name: string,
    resultCount?: number,
    selected?: boolean,
    disabled?: boolean,
    disableFacet?: boolean,
    onChange?: (value: IOption | undefined) => void
}

export class FilterOption extends React.Component<FilterOptionProps> {
    constructor(props: FilterOptionProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    public render() {
        return <label className={`input-checkbox ${this.props.disabled ? "disabled" : ""}`}>
            <input type="checkbox"
                   checked={this.props.selected}
                   disabled={this.props.disabled}
                   onChange={this.onChange}/>
            <span/>
            {this.props.name}
            {!this.props.disableFacet ? <small> ({this.props.resultCount})</small> : undefined }
        </label>;
    }

    private onChange(e: ChangeEvent<HTMLInputElement>) {
        if (this.props.onChange) {
            this.props.onChange(e.target.checked ? {key: this.props.id, name: this.props.name}: undefined);
        }
    }
}


// WEBPACK FOOTER //
// ./src/homepage/components/filters/FilterOption.tsx